module.exports = __webpack_public_path__ + "static/media/security.7edbd7c5.svg";